import { ChangeDetectorRef, Component, Inject, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BookingCommonComponent } from '../../booking-common.component';
import { environment } from '../../../../environments/environment';
import { FacilitySummary } from '../../../models/asset/facility-summary';
import { Booking } from '../../../models/booking/booking';
import { CalenderTimeslot, Timeslot } from '../../../models/asset/timeslots';
import { MatMenuTrigger } from '@angular/material/menu';
import { AddFacility, DeleteFacilityPrice, EditFacility, ICart, Store, UpdateBookingPackage, UpdateFacility } from '../../../store';
import { AppSetting } from '../../../models/settings/casual-portal/app-setting';
import { PackageFilter } from '../../../models/booking/common';
import { BespokePackage } from '../../../models/asset/bespoke-package';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AssetService } from '../../../services/asset.service';
import { ItemService } from '../../../services/item.service';
import { PackageService } from '../../../services/package.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Utility } from '../../../utility';
import { Action, ErrorType } from '../../../models/enum';
import { FacilityAdaptor } from '../../../models/asset/facility-adaptor';
import { Item, ItemAssets, SalesCategory, SpaceItem, UpsellSummary } from '../../../models/item/item';
import { SuccessMessageComponent } from '../../../shared/success-message/success-message.component';
import { AlternativeOptionsComponent } from '../edit-modal/alternative-options/alternative-options.component';
import { Configuration } from '../../../models/asset/configuration';
import { BookingAdaptor } from '../../../models/booking/booking-adaptor';
import { DecimalPipe } from '@angular/common';
import { UserDefinedFunction } from '../../../models/system/user-defined-function';
import { DeleteConfirmationComponent } from '../../../shared/delete-confirmation/delete-confirmation.component';
import { PackageQuestionPopupHidden, PackageQuestionPopupShown } from '../../../store/actions';
import { AlertMessageComponent } from '../../../shared/alert-message/alert-message.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '../../common/date-time-adapter/moment-date-adapter';
import { default as _rollupMoment } from 'moment/moment';
import * as _moment from 'moment/moment';
import { Assetsearchparams } from '../../../models/asset/asset-search-params';
import { tr } from 'date-fns/locale';
import { ItemSearchParams } from '../../../models/item/item-search-params';
import { FacilitySearchLoaded, FacilitySearchLoading, ILoadingStatus } from '../../../store/loading';
import { name } from '@azure/msal-angular/packageMetadata';
import { BookingService } from '../../../services/booking.service';
import {Allocations} from '../../../models/booking/allocations';
import {Asset} from '../../../models/booking/asset';

const moment = _rollupMoment || _moment;


export const MY_FORMATS = {
  parse: { dateInput: 'LL' },
  display: {
    dateInput: 'DD MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'opt-edit-modal-combined-room',
  templateUrl: './edit-modal-combined-room.component.html',
  styleUrls: [],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class EditModalCombinedRoomComponent extends BookingCommonComponent implements OnInit, OnDestroy {
  imagepath: string = environment.ApiUrl + environment.publishFolder;

  date = moment();
  facilitySummary: FacilitySummary;
  booking = new Booking;
  startTime: Date;
  endTime: Date;

  selected = 'option1';

  //select-configuration
  configurationDisplayMode: any;
  isConfigurationEnabled: boolean;
  isCategoryAndEventEnabled: boolean;
  isCategoryAndEventMandatory: boolean;
  // time picker validation
  minDate: Date = new Date();
  maxDate: Date;
  minStartDate: Date;
  maxStartDate: Date;
  minEndDate: Date;
  maxEndDate: Date;
  isValidStart: boolean;
  isValidEnd: boolean;

  attendees: number;
  isAvailable: boolean = false;
  showUnavailableMessage: boolean = false;
  isAddFacility = false;
  //timeWithBumpIn: Date;
  //timeWithBumpOut: Date;
  isCheckAvailabilityTriggered: boolean = false;
  showUnavailableFutureDateMessage: boolean = false;
  IsDateChangeFromCalendar: boolean = true;
  showUnavailableFutureDateErrorMessage: string;
  showUnavailableOperationalMessage: boolean = false;
  selectedPackageClass: any;
  selectedClass: number;
  showBookingLeadDayValidationMessage: boolean = false;
  bookingLeadDayValidationMessage: any;
  isBookingAdded: boolean = false;
  isBookingLeadDaysError: boolean = false;

  displayBumpInOutNotification: boolean;

  timeLineColors: any;
  isSystemAllowedImmediateConfirmation: boolean;
  systemDefaultPriceConsessionId: number;

  facilitySummaries: FacilitySummary[] = [];

  availableSlots: CalenderTimeslot[] = [];
  panelOpenState: boolean;
  isEnableAutoAvailabilityCheck: boolean = false;
  @ViewChild('hoverStartMenuTrigger') starttrigger: MatMenuTrigger;
  @ViewChild('hoverEndMenuTrigger') endtrigger: MatMenuTrigger;
  isEnableTimeLineAdvancedMode: boolean;
  startChangedByTimeslotClick: number = 0;
  endChangedByTimeslotClick: number = 0;

  errorMessages: string[] = [];
  warningMessages: string[] = [];

  cartData: ICart;

  AppData: AppSetting;

  continueProcess: boolean;

  packageFilter: PackageFilter;
  selectedPackage: string;
  selectedPackageDetail: BespokePackage;
  defaultEventName: string;
  packageClasses: any[] = [];
  selectedBusinessArea: string;
  packages: BespokePackage[] = [];
  packageDetail: BespokePackage;
  isValidPackage: boolean;
  packageSelected: BespokePackage;
  isContinueProcessOnpackageChange: boolean = true;
  isContinueProcessOnTimeChange: boolean = true;
  isStartTimeChanged: boolean;
  isShowQuestionsUpdate: boolean = false;

  attendeesSubs: Subscription;
  attendessControl = new FormControl();
  timechange: boolean = false;
  itemUnavailableMessages: string;
  filteredPackages: BespokePackage[] = [];
  itemidlist: number[] = [];
  itemSubcription: any;
  cart_subscriber: any;
  searchFacilities: FacilitySummary[] = [];
  disableActivityDropdown: boolean = false;

  //assetIds: string = '';
  activityMatchingItems: Item[] = [];
  matchingItems: Item[] = [];
  selectedItemId: string = null;//added for UI binding purpose , otherwise when configuration change item not reset
  allConfigurations: Configuration[] = [];
  filterConfigurations: Configuration[] = [];
  uniqueConfigurationNames: { id: string, name: string }[] = [];
  selectedConfiguration: { id: string, name: string } = { id: "", name: "" };

  addedFacilityIDs = new Set<string>();

  facilityOpeningTime: string;
  facilityClosingTime: string;
  hasDiaryNote: boolean = false;
  isFacilityClosed: boolean = false;
  //selectedConfigurationMatchedItems: Item[] = []

  showBookingPackageLevelLeadDayValidationMessage: boolean = false;
  bookingPackageLevelLeadDayValidationMessage: any;
  remainingLeadDaysList: { id: string, remainingLeadDays: number }[] = [];
  remainingPackageLeadDaysList: { id: string, remainingLeadDays: number }[] = [];
  hasExecuted: boolean = false;
  loading: boolean = true;
  availableSlotsLoading: boolean = false;
  changeTimeLineLoading : boolean = false;
  activeRequests = 0;
  changeTimeLineActiveRequests = 0;
  customFunctionActiveRequests = 0;
  cartPackageCustomFunctionActiveRequests = 0;
  constructor(public dialogRef: MatDialogRef<EditModalCombinedRoomComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private _assetService: AssetService, private _bookingService: BookingService,
    private _itemService: ItemService, private _packageService: PackageService, private store: Store<any>, private cdr: ChangeDetectorRef, public snackBar: MatSnackBar) {
    super(store, _itemService, snackBar);
    this.AppData = environment.AppSetting as AppSetting;
    this.maxDate = new Date(environment.LatestFutureBookingDate);

    this.timeLineColors = environment.CheckAvailability.TimeLineColors;

    this.facilitySummary = data.facility;


    this.searchFacilities = [this.facilitySummary];
    this.selectedPackageClass = data.selectedPackageClass;
    // this.assetIds = this.facilitySummary?.multiPurposeIds ?? "";
    this.panelOpenState = true;//this.AppData.BookingConfig.IsDefaultExpandAlternativeConfigurationForFacility;


    if (this.facilitySummary) {
      this.facilitySummary.timeslotLoaded = false;
      this.startTime = Utility.convertISOToDate(this.facilitySummary.startTime);
      this.endTime = Utility.convertISOToDate(this.facilitySummary.endTime);
      this.attendees = this.facilitySummary.attendees;

      this.displayBumpInOutNotification = environment.ConfigurationSelection.DisplayBumpInOutNotification;
      this.date = moment(this.facilitySummary.startTime);
    }


    this.booking = new Booking();
    if (data.isaddfacility != undefined || data.isaddfacility != null) {
      this.isAddFacility = data.isaddfacility;
    }

    this.isSystemAllowedImmediateConfirmation = environment.ImmediateConfirmation.Allow;
    this.systemDefaultPriceConsessionId = environment.ImmediateConfirmation.DefaultPriceConsessionId;

    this.initializeTime();
    this.checkAvailability();

    this.AppData = environment.AppSetting as AppSetting;

    this.attendeesSubs = this.attendessControl.valueChanges
      .debounceTime(1500)
      .subscribe(e => {
        let itm = this.getItem();// (this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem : this.facilitySummary.item);

        // onchanging number of attendees if price typee cover
        if ((itm.itemMinPrice && itm.itemMinPrice.priceType.toLowerCase() == 'covers') || (itm.itemMaxPrice && itm.itemMaxPrice.priceType.toLowerCase() == 'covers')) {
          this.facilitySummary.attendees = this.attendees;
          //remove calling calcukate price untill item select
          //this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

        }
      });


  }

  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  ngOnInit() {
    super.ngOnInit();
    this.isConfigurationEnabled = environment.ConfigurationSelection.Enabled;

    this.isItemPricesLoaded = true;
    this.loadCombinedRoomFacilities()
    this.hasExecuted = false;
    this.validateAvailability();

    this.cart$.safeSubscribe(this, state => {
      this.booking = state.booking;
      this.facilitySummaries = state.addedFacilites;
      this.cartData = state as ICart;

      this.packages = state.bespokePackages;
      if (state.packageFilter != undefined && state.packageFilter != null) {
        this.packageFilter = state.packageFilter;
        if (state.packageFilter?.Package) {
          this.selectedPackage = state.packageFilter.Package.toString();
          this.selectedPackageDetail = state.packageFilter.PackageDetail;
        }
        this.defaultEventName = state.packageFilter.EventName;
        if (state != undefined && state.packageFilter != undefined && state.packageFilter != null) {
          this.packageClasses = state.packageFilter.FilteredPackageClasses;
          //this.selectedPackageClass = this.packageClasses.find(a => a.Id == state.packageFilter.PackageClass);
        }


      }
      this.packageDetail = state.packageFilter?.PackageDetail;
      if ((!state.addedFacilites) || (state.addedFacilites && state.addedFacilites.length == 0)) {
        this.validatePackageClass(state);
      }
      if (this.filteredPackages.length == 0) {
        this.filteredPackages = this.selectPackageList();
      }

      if (this.addedFacilityIDs.size == 0) {
        if (this.facilitySummaries != null && this.facilitySummaries?.length > 0) {
          this.facilitySummaries.forEach(fs => {
            if (fs?.ItemAssetsToBook?.length > 0) {
              fs.ItemAssetsToBook.forEach(iab => {
                this.addedFacilityIDs.add(iab.asset.id);
              });
            }
          });
        }
      }

      if (!this.hasExecuted) {
        this.hasExecuted = true;
        var leadDays = this.getLeadDays(this.selectedPackage != "" ? this.selectedPackage : "");
        this.setLeadDaysIntoCalander(leadDays, true)

        this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
        this.setPackageRemainingLeadDaysList(this.startTime, this.packages)
        this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage);
        this.CallPackageChangeValidation();
      }

    });
    /*  if (this.selectedPackage != null && this.selectedPackage != '') {
       this.disableActivityDropdown = true;
     } */
    this.onGetFilterdItemsBySelectedActivity(this.selectedPackage != "" ? this.selectedPackage : '');

    var leadDays = (environment.LeadDaysForBooking == null) ? 0 : environment.LeadDaysForBooking;
    if (environment.DisableDatePickerForLeadDays) {
      var currentDate = new Date();
      currentDate.setDate(currentDate.getDate() + leadDays);
      this.minDate = currentDate;
    }

    this.configurationDisplayMode = environment.ConfigurationSelection.DisplayMode;

    this.isEnableAutoAvailabilityCheck = environment.CheckAvailability.EnableAutoAvailabilityCheck;

    this.isCategoryAndEventEnabled = this.AppData.AddEditPopupPageSettings.EnableCategoryAndEventSelection;
    this.isCategoryAndEventMandatory = this.AppData.AddEditPopupPageSettings.MandatoryCategoryAndEventSelection;


    this.isEnableTimeLineAdvancedMode = environment.CheckAvailability.EnableTimeLineAdvancedMode;

    //this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

    /*this.getCombinedRoomFacilities();*/
    // this.onGetfilterActivityUsingItems(this.packages, this.facilitySummary.items)
    /*this.onGetFilterdConfiguration();*/
  }
  // Wrap the async call in a separate method
  async loadCombinedRoomFacilities() {
    try {
      await this.getCombinedRoomFacilities();
      this.allConfigurations = this.facilitySummary.multiPurposeAssets.reduce((acc, facility) => {
        return acc.concat(facility.configurations); // Flatten the array
      }, []);
      this.onGetFilterdConfiguration();
      if (this.isConfigurationEnabled) {
        this.getImagesforConfigurations();
      }
    } catch (error) {
      console.error('Error loading combined room facilities:', error);
    }
  }
  public close() {
    this.dialogRef.close(this.facilitySummary);
  }

  add(val) {
    this.attendees = ((this.attendees + val) <= 0) ? 0 : this.attendees + val;
  }

  async refreshBooking(facility: FacilitySummary) {
    var thisPage = this;


    if (this.isBookable()) {

      let _validationOutPut;

      if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
        let exsitingfacilitySummaries = (this.cartData.addedFacilites ?? [])
          .filter(f => f !== facility);
        _validationOutPut = await this.CallCustomFunction(facility, Action.OnUpdateBookingItem, this.getPackageDetail(), exsitingfacilitySummaries);
      }

      if (!_validationOutPut || (_validationOutPut && _validationOutPut.ContinueProcess)) {
        facility.attendees = this.attendees;
        facility.startTime = this.getFormattedDate(this.startTime);
        facility.endTime = this.getFormattedDate(this.endTime);

        if (this.facilitySummary.selectedItem != undefined) {
          FacilityAdaptor.changeFacilityItem(this.facilitySummary, this.facilitySummary.selectedItem, this.facilitySummary.selectedConfiguration);
          this.facilitySummary.selectedConfiguration = this.facilitySummary?.selectedConfiguration ?? this.getConfigurationBasedOnItemAndConfiguration(this.facilitySummary.selectedItem);
          this.facilitySummary.configuration = this.facilitySummary.selectedConfiguration;
          this.facilitySummary.ItemAssetsToBook = this.getAllocationInfo(this.facilitySummary.selectedItem);

          if ((this.facilitySummary.ItemAssetsToBook?? []).length > 0) {
            facility.allocations = [];
            (this.facilitySummary.ItemAssetsToBook ?? []).forEach((itm, index) => {
                var allocation = new Allocations();
                allocation.timeslot.asset = new Asset();
                allocation.attendees = facility.attendees;
                allocation.timeslot.startTime = facility.startTime;
                allocation.timeslot.endTime = facility.endTime;

                allocation.timeslot.asset.id = itm.asset.id;
                allocation.timeslot.eventConfiguration.id = (itm.configuration?.id ?? "").toString();
                facility.allocations.push(allocation);
              }
            )
          }

        }


        this.store.dispatch(new DeleteFacilityPrice(facility));
        if (environment.PriceDisplayOption == 3) {
          //     FacilityAdaptor.populateItemPrice(facility, this.selectedClass);
        }


        this.store.dispatch(new EditFacility(facility));

        this.calculateItemPrices([facility], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

        if (facility.upsellSummaries != undefined && facility.upsellSummaries.length > 0) {
          let time = 0;
          facility.upsellSummaries.forEach(function (us) {
            if (us.minPrice == undefined || us.maxPrice == undefined || (us.minPrice.priceTypeId != 5 && us.minPrice.priceTypeId != 7 && us.maxPrice.priceTypeId != 5 && us.maxPrice.priceTypeId != 7)) {
              time = time + 150;
              setTimeout(function () {
                thisPage.calculateUpsellItemPrice(us, facility, facility.startTime, facility.endTime);
              }, time);
            }
          });
        }

        this.updateQuestionPopupState();

        this.dialogRef.close(facility);


      }
    }
  }

  calculateUpsellItemPrice(upsell: UpsellSummary, fc: FacilitySummary, startTime, endTime) {
    var thisPage = this;
    if (this.selectedPackageClass == undefined) {
      return;
    }

    upsell.minPrice = undefined;
    upsell.maxPrice = undefined;
    upsell.startTime = Utility.convertToISO(Utility.convertISOToDate(startTime));
    upsell.endTime = Utility.convertToISO(Utility.convertISOToDate(endTime));

    let packageClassId = (this.selectedPackageClass && !isNaN(this.selectedPackageClass)) ? this.selectedPackageClass : environment.DefaultPackageClassId;
    let concessionsId = FacilityAdaptor.getBookingPriceConcession(this.customerDefaultPriceConsessionId, this.isAllImmediateConfirmed);

    let res = FacilityAdaptor.getMinMaxPriceConcessionForUpsell(concessionsId, packageClassId);
    let minConcessionsId = res.minPriceConcession;
    let maxConcessionsId = res.maxPriceConcession;

    // for min price
    let count = 0;
    this._itemService.CalculateItemPrice(upsell.id, minConcessionsId, ((upsell.isSystemGenerated && (upsell.priceTypeId == 7 || upsell.priceTypeId == 10)) ? (fc.attendees ?? upsell.qty) : upsell.qty), upsell.startTime, upsell.endTime)
      .subscribe((result) => {
        if (result.calculatedItemPriceGroups != undefined && result.calculatedItemPriceGroups.length > 0) {
          result.calculatedItemPriceGroups.forEach((cip, i) => {
            if (!(cip instanceof Array)) {
              if (cip.priceIncludingTax != 0) {
                upsell.minPrice = cip;
              }
            }
          });
        }

        count++;
        if (count == 2) {
          thisPage.setUpsellPrices(upsell);
        }
      },
        err => {
          console.log('Error : calculateUpsellItemPrice - min  ' + upsell.name, err);
          count++;
          if (count == 2) {
            thisPage.setUpsellPrices(upsell);
          }
        }
      );

    // for max price
    setTimeout(function () {
      thisPage._itemService.CalculateItemPrice(upsell.id, maxConcessionsId, ((upsell.isSystemGenerated && (upsell.priceTypeId == 7 || upsell.priceTypeId == 10)) ? (fc.attendees ?? upsell.qty) : upsell.qty), upsell.startTime, upsell.endTime)
        .subscribe((result) => {
          if (result.calculatedItemPriceGroups != undefined && result.calculatedItemPriceGroups.length > 0) {
            result.calculatedItemPriceGroups.forEach((cip, i) => {
              if (!(cip instanceof Array)) {
                if (cip.priceIncludingTax != 0) {
                  upsell.maxPrice = cip;
                }
              }
            });
          }

          count++;
          if (count == 2) {
            thisPage.setUpsellPrices(upsell);
          }
        },
          err => {
            console.log('Error : calculateUpsellItemPrice - max  ' + upsell.name, err);
            count++;
            if (count == 2) {
              thisPage.setUpsellPrices(upsell);
            }
          }
        );
    }, 80);
  }

  setUpsellPrices(upsell: UpsellSummary) {
    upsell.minPrice = (upsell.minPrice == undefined || upsell.minPrice == null) ? upsell.maxPrice : upsell.minPrice;
    upsell.maxPrice = (upsell.maxPrice == undefined || upsell.maxPrice == null) ? upsell.minPrice : upsell.maxPrice;
    this.store.dispatch(new UpdateFacility(this.facilitySummary));
  }

  checkAvailability() {
    var current = moment().startOf('day');
    this.showBookingLeadDayValidationMessage = false;
    this.showUnavailableFutureDateMessage = false;
    this.showUnavailableOperationalMessage = false;
    this.showBookingPackageLevelLeadDayValidationMessage = false;
    this.availableSlotsLoading = true;
    var selectedDate = this.date.toDate();
    selectedDate.setHours(0, 0, 0, 0);
    var futureDate = new Date(environment.LatestFutureBookingDate);
    futureDate.setHours(0, 0, 0);
    var leadDays = this.getLeadDays(this.selectedPackage != "" ? this.selectedPackage : "");
    this.setLeadDaysIntoCalander(leadDays)
    this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
    this.setPackageRemainingLeadDaysList(this.startTime, this.packages);
    this.isFacilityClosed = FacilityAdaptor.isFacilityClosed(this.facilitySummary, selectedDate);
    if (selectedDate > futureDate) {
      this.showUnavailableFutureDateMessage = true;
      this.showUnavailableFutureDateErrorMessage = environment.LatestFutureBookingDateErrorMessage.replace('#FacilityName#', this.facilitySummary.name);
      this.showUnavailableFutureDateErrorMessage = this.showUnavailableFutureDateErrorMessage.replace('#LatestFutureBookingDate#', moment(environment.LatestFutureBookingDate).format(environment.DateFormat.toUpperCase()).toString());
      this.isAvailable = false;
      this.availableSlotsLoading = true;
      return;
    }
    var daysCount = this.date.diff(current, 'days');
    var leadDays = (environment.LeadDaysForBooking == null) ? 0 : environment.LeadDaysForBooking;
    this.isBookingLeadDaysError = false;

    if (!this.checkRemainingLeadDaysCount(
      (this.facilitySummary?.selectedItem != undefined ? this.facilitySummary?.selectedItem?.id : this.facilitySummary?.item?.id) ?? null, null)) {
      this.bookingLeadDayValidationMessage = (environment?.BookingLeadDayValidationMessage ?? "").replace("#LeadDays#", leadDays.toString());
      this.showBookingLeadDayValidationMessage = true;
      this.isAvailable = false;
      this.isBookingLeadDaysError = true;
      this.showBookingPackageLevelLeadDayValidationMessage = false;
      this.availableSlotsLoading = true;
      return
    }
    this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage ?? "")

    if (this.isValidStart && this.isValidEnd) {
      this.isCheckAvailabilityTriggered = true;
      this.validateAvailability();
    }

    if (this.isEnableAutoAvailabilityCheck && this.facilitySummary.selectedItem != null) {
      this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime), false, true);
    }

  }

  getStartEndTime() {
    //let startTime = this.getFormattedDate(this.startTime);
    //let endTime = this.getFormattedDate(this.endTime);
    let timeWithBumpIn = new Date(this.startTime);
    let timeWithBumpOut = new Date(this.endTime);
    var cnf = this.getSelectedConfiguration();
    if (cnf) {
      if (cnf.setupTime && cnf.setupTime > 0) {
        timeWithBumpIn.setMinutes(timeWithBumpIn.getMinutes() - cnf.setupTime);
        //startTime = this.getFormattedDate(timeWithBumpIn);
      }
      if (cnf.teardownTime && cnf.teardownTime > 0 && !cnf.isSystemOverride) {
        timeWithBumpOut.setMinutes(timeWithBumpOut.getMinutes() + cnf.teardownTime);
        // endTime = this.getFormattedDate(timeWithBumpOut);
        //15181
        let maxEndTime = new Date(this.endTime);
        maxEndTime.setHours(24, 0, 0);
        if (Utility.convertToISO(timeWithBumpOut) == Utility.convertToISO(maxEndTime)) {
          timeWithBumpOut = new Date((new Date(this.endTime)).setHours(23, 59, 0, 0));
        }
      }
    }
    return { start: timeWithBumpIn, end: timeWithBumpOut };
  }

  async validateAvailability() {
    if (this.showUnavailableOperationalMessage) {
      return;
    }


    if (this.facilitySummary.facilityTypeId && environment.BookingRestrictions && environment.BookingRestrictions.length > 0) {
      var FCMaxtime = environment.BookingRestrictions.find(ftm => ftm.Id == this.facilitySummary.facilityTypeId);
      if (FCMaxtime && FCMaxtime.MaxNoOfBookingMinutes) {
        var diff = (new Date(this.endTime).getTime() - new Date(this.startTime).getTime()) / 1000;
        diff /= 60;
        let totalBookingMins = Math.abs(Math.round(diff));
        if (totalBookingMins > FCMaxtime.MaxNoOfBookingMinutes) {
          this.showUnavailableFutureDateMessage = true;
          this.showUnavailableFutureDateErrorMessage = 'You may book this venue for max ' + (FCMaxtime.MaxNoOfBookingMinutes % 60 == 0 ? ((FCMaxtime.MaxNoOfBookingMinutes / 60) + ' hours') : (FCMaxtime.MaxNoOfBookingMinutes + ' minutes')) + '. Please adjust the duration of the booking to proceed. ';
          this.isAvailable = false;
          return;
        }

      }

    }

    // let fcArr = [];
    // fcArr.push(this.facilitySummary);

    if (this.facilitySummary) {
      let startEndTime = this.getStartEndTime();
      let startTime = this.getFormattedDate(startEndTime.start);
      let endTime = this.getFormattedDate(startEndTime.end);
      var isBookingForNonOperationalHours = this.validateNonOperationalHours(startEndTime.start, startEndTime.end);
      let _cn = this.getSelectedConfiguration();
      if (_cn) {
        if (_cn.isSystemOverride) {
          if (_cn.teardownTime && _cn.teardownTime > 0) {
            endTime = Utility.convertToISO(new Date(new Date(endTime).getTime() + _cn.teardownTime * 60000));
          }
        }
      }

      if (!isBookingForNonOperationalHours && this.facilitySummary.selectedItem != null) {
        let _assetsLinkedToSelectedItem = this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem.itemAssets.map(s => s.asset?.id) : []

        let _fcArr = (_assetsLinkedToSelectedItem ?? []).length > 0 ? this.facilitySummary.multiPurposeAssets.filter(d => _assetsLinkedToSelectedItem.findIndex(f => f == d.id) >= 0) : this.facilitySummary.multiPurposeAssets;

        let _isMultiPurpose = (this.facilitySummary.multiPurposeIds ?? "") != "";
        if (_isMultiPurpose) {
          // API avaibility Validation
          let _assetsIds = this.facilitySummary.selectedItem.itemAssets.map(obj => obj.asset.id).join(',');
          let availablityResult = this._assetService.timeslotSearch(_assetsIds, startTime, endTime);

          availablityResult.subscribe(res => {
            this.activeRequests++;
            if (this.facilitySummary?.selectedItem?.allocateToAllAssets) {
              if (environment.CheckAvailability.DisplayPreliminarySlotAsUnavailble || res.length < 1 || res == undefined) {
                this.isAvailable = (res.length < 1);
                this.showUnavailableMessage = !(res.length < 1);
              } else {
                var bookedSlot = res.filter(re => re.preliminary == false || re.preliminary === undefined);
                this.isAvailable = !(bookedSlot && bookedSlot.length > 0);
                this.showUnavailableMessage = (bookedSlot && bookedSlot.length > 0);
              }
            } else {
              let _available = false;
              this.facilitySummary?.selectedItem?.itemAssets?.forEach((itm, index) => {
                if (!_available) {
                  let _timeslots = res.filter(r => r.asset?.id == itm.asset.id)
                  if (environment.CheckAvailability.DisplayPreliminarySlotAsUnavailble || _timeslots.length < 1 || _timeslots == undefined) {

                    _available = (_timeslots.length < 1);
                  } else {
                    var bookedSlot = _timeslots.filter(re => re.preliminary == false || re.preliminary === undefined);

                    _available = !(bookedSlot && bookedSlot.length > 0);
                  }
                  this.isAvailable = _available;
                  this.showUnavailableMessage = !(_available);
                }
              })

            }

          },
            err => {
              console.log('Error', err);
              this.isAvailable = false;
              this.showUnavailableMessage = true;
              this.availableSlotsLoading = false;
            },
            () => {
              this.activeRequests--;
              if (this.activeRequests <= 0) {
                this.availableSlotsLoading = false;
              }
            }
          );

          //validate within booking
          let _available = this.validateAvailabilityWithinSameBooking()
          this.isAvailable = _available;
          this.showUnavailableMessage = !(_available);
        }
        else {

          let availablityResult = this._assetService.timeslotSearch(this.facilitySummary.id, startTime, endTime);

          availablityResult.subscribe(res => {
            this.activeRequests++;
            if (environment.CheckAvailability.DisplayPreliminarySlotAsUnavailble || res.length < 1 || res == undefined) {
              this.isAvailable = (res.length < 1);
              this.showUnavailableMessage = !(res.length < 1);
            } else {
              var bookedSlot = res.filter(re => re.preliminary == false || re.preliminary === undefined);
              this.isAvailable = !(bookedSlot && bookedSlot.length > 0);
              this.showUnavailableMessage = (bookedSlot && bookedSlot.length > 0);
            }
          },
            err => {
              console.log('Error', err);
              this.isAvailable = false;
              this.availableSlotsLoading = false;
            },
            () => {
              this.activeRequests--;
              if (this.activeRequests <= 0) {
                this.availableSlotsLoading = false;
              }
            }
          );
        }
      } else {
        this.availableSlotsLoading = false;
      }


    }
  }

  validateAvailabilityWithinSameBooking(fcs: FacilitySummary = undefined) {

    let _available = false;
    let _payloadStartTime = Utility.convertToISO(this.startTime);
    let _payloadEndTime = Utility.convertToISO(this.endTime);



    var _sameSlots = this.addedFacilities.filter(f => f.startTime == _payloadStartTime && f.endTime == _payloadEndTime)
    if ((_sameSlots ?? []).length > 0) {
      if (fcs) {
        let _crossingSlots = _sameSlots.filter(t => this.facilitySummary.selectedItem.itemAssets.findIndex(s => s.asset.id == fcs.id));
        _available = (_crossingSlots ?? []).length == 0;
      } else {
        if (this.facilitySummary.selectedItem.allocateToAllAssets) {
          let _crossingSlots = _sameSlots.filter(t => this.facilitySummary.selectedItem.itemAssets.findIndex(s => s.asset.id == t.id));
          _available = (_crossingSlots ?? []).length == 0;
        } else {

          this.facilitySummary.selectedItem.itemAssets.forEach((itm, index) => {
            if (_available) {
              let _crossingSlots = _sameSlots.filter(t => this.facilitySummary.selectedItem.itemAssets.findIndex(s => s.asset.id == t.id));
              if ((_crossingSlots ?? []).length == 0) {
                _available = true;
              }
            }
          });

        }
      }

    } else {
      _available = true;
    }

    return _available;
  }
  validateNonOperationalHours(searchStartTime: Date, searchEndTime: Date) {
    var isBookingForNonOperationalHours = false;
    if (!environment.AllowToDoBookingForNonOperationalHours) {
      let _cn = this.getSelectedConfiguration();
      if (_cn) {
        if (_cn.isSystemOverride) {
          if (_cn.previousTeardownTime && _cn.previousTeardownTime > 0) {
            searchEndTime = new Date(new Date(searchEndTime).getTime() + _cn.previousTeardownTime * 60000);

            let maxEndTime = new Date(this.endTime);
            maxEndTime.setHours(24, 0, 0)
            if (Utility.convertToISO(searchEndTime) == Utility.convertToISO(maxEndTime)) {
              searchEndTime = new Date((new Date(this.endTime)).setHours(23, 59, 0, 0))
            }
          }
        }
      }
      const { openingTime, closingTime } = FacilityAdaptor.getOpeningClosingTimes(this.facilitySummary, this.startTime);
      this.facilityOpeningTime = openingTime.toString();
      this.facilityClosingTime = closingTime.toString();
      if (this.facilitySummary.openingTime) {
        let _openingTime = Utility.changeDatePart(Utility.convertISOToDate(openingTime), Utility.convertISOToDate(this.getFormattedDate(this.startTime)));
        if (searchStartTime < _openingTime && searchStartTime.toTimeString() != _openingTime.toTimeString()) {
          this.showUnavailableOperationalMessage = true;
          this.isAvailable = false;
          isBookingForNonOperationalHours = true;
          // return;
        }
      }
      if (this.facilitySummary.closingTime) {
        let _closingTime = Utility.changeDatePart(Utility.convertISOToDate(closingTime), Utility.convertISOToDate(this.getFormattedDate(this.endTime)));
        if (searchEndTime > _closingTime && searchEndTime.toTimeString() != _closingTime.toTimeString()) {
          this.showUnavailableOperationalMessage = true;
          isBookingForNonOperationalHours = true;
          this.isAvailable = false;
          //  return;
        }
      }
    }
    if (!isBookingForNonOperationalHours) {
      this.showUnavailableOperationalMessage = false;
    }

    return isBookingForNonOperationalHours;
  }

  getFormattedDate(selected: Date) {
    let searchabledate = new Date(this.date.year(), this.date.month(), this.date.date());
    if (selected) {
      searchabledate.setHours(selected.getHours(), selected.getMinutes(), selected.getSeconds());
    }
    return Utility.convertToISO(searchabledate);
  }

  attendeesChanged(val) {
    if (new String(val).length > 5) {
      val = +String(val).slice(0, 5);
    }
  }

  displayBumpIn(date: Date) {
    let tempDate = new Date(date);
    tempDate.setMinutes(tempDate.getMinutes() - this.facilitySummary.configuration.setupTime);
    return tempDate;
  }

  displayBumpOut(date: Date) {
    let tempDate = new Date(date);
    tempDate.setMinutes(tempDate.getMinutes() + this.facilitySummary.configuration.teardownTime);
    return tempDate;
  }


  async addBooking(action: string) {


    if (this.isBookable()) {
      //this.facilitySummary.multiPurposeIds = this.assetIds;
      this.isBookingAdded = true;
      this.facilitySummary.startTime = this.getFormattedDate(this.startTime);
      this.facilitySummary.endTime = this.getFormattedDate(this.endTime);
      this.facilitySummary.attendees = (this.attendees == null || isNaN(this.attendees) || this.attendees == 0) ? 1 : this.attendees;

      if (this.facilitySummary.selectedItem != undefined) {
        FacilityAdaptor.changeFacilityItem(this.facilitySummary, this.facilitySummary.selectedItem, this.facilitySummary.selectedConfiguration);
        this.facilitySummary.selectedConfiguration = this.getConfigurationBasedOnItemAndConfiguration(this.facilitySummary.selectedItem);
        this.facilitySummary.configuration = this.facilitySummary.selectedConfiguration;
      }


      this.facilitySummary.ItemAssetsToBook = this.getAllocationInfo(this.facilitySummary.selectedItem);

      //this.facilitySummary.configuration = FacilityAdaptor.getConfiguration(this.facilitySummary.item, this.facilitySummary);


      //validateOnAddToBooking

      let _validationOutPut;


      if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
        let exsitingfacilitySummaries = (this.cartData.addedFacilites ?? [])
          .filter(f => f !== this.facilitySummary);
        _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnAddItemToBooking, this.getPackageDetail(), exsitingfacilitySummaries);
      }

      if (!_validationOutPut || (_validationOutPut && _validationOutPut.ContinueProcess)) {
        this.updateQuestionPopupState();
        //action 0:Add More Venues;  1: Book Now
        if (action == '0') {
          let _deepClonefcs = JSON.parse(JSON.stringify(this.facilitySummary));
          this.store.dispatch(new AddFacility(_deepClonefcs, action));
        } else if (action == '1') {
          this.store.dispatch(new AddFacility(this.facilitySummary, action));
        }
        let filter = this.getPackageFilter();
        this.store.dispatch(new UpdateBookingPackage(filter));

        this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

        var n = 0;
        //setTimeout(() => {
        //    n = n + 10;
        //    this.isBookingAdded = false;
        //    this.dialogRef.close(this.facilitySummary);
        //}, 2000);

        if (action == '0') {
          this.snackBar.openFromComponent(SuccessMessageComponent, {
            data: 'Cart updated successfully with ' + this.facilitySummary.name + '.',
            duration: 5000,
            verticalPosition: 'top',
          });
          // setTimeout(() => {
          //   n = n + 10;
          //   this.isBookingAdded = false;
          //   this.dialogRef.close();
          // }, 2000);
        }
        setTimeout(() => {
          n = n + 10;
          this.isBookingAdded = false;

          //action 0:Add More Venues;  1: Book Now
          this.dialogRef.close(action);

        }, 2000);
      }

    }
    return;
  }

  //#region time picker

  initializeTime(): void {
    this.minStartDate = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
    this.maxStartDate = new Date();
    this.maxStartDate.setHours(24, 0, 0);
    this.maxStartDate = moment(this.maxStartDate).add(environment.MinimumBookingDuration * -1, 'm').toDate();

    this.minEndDate = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();
    this.maxEndDate = new Date();
    this.maxEndDate.setHours(24, 0, 0);
    this.dateChanged();
  }

  async dateChanged() {

    this.showBookingLeadDayValidationMessage = false;
    this.showUnavailableFutureDateMessage = false;
    this.isAvailable = false;
    this.showUnavailableMessage = false;
    this.IsDateChangeFromCalendar = true;
    this.startTime = Utility.changeDatePart(this.startTime, this.date.toDate());
    var dt = this.date.toDate();
    var today = new Date();


    if (!(dt.getFullYear() == today.getFullYear() && dt.getMonth() == today.getMonth() && dt.getDate() == today.getDate())) {
      dt.setHours(0, 0, 0);
      this.minStartDate = dt;
    } else {
      if (new Date(this.startTime) < new Date()) {
        this.startTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
      } else {
        let newStartTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
        if (this.startTime) {
          newStartTime.setHours(this.startTime.getHours());
          newStartTime.setMinutes(this.startTime.getMinutes());
          this.startTime = newStartTime;
        }
      }
      this.minStartDate = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
    }

    this.maxStartDate = Utility.changeDatePart(new Date(this.maxStartDate), this.date.toDate());
    this.maxStartDate.setMinutes(this.maxStartDate.getMinutes() + 1);
    let newEndTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();

    if (this.endTime) {
      newEndTime.setHours(this.endTime.getHours());
      newEndTime.setMinutes(this.endTime.getMinutes());
      this.endTime = newEndTime;
    }

    this.minEndDate = new Date(moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate());
    this.maxEndDate = new Date(this.minEndDate);
    this.maxEndDate.setHours(24, 0, 0);

    var selectedDate = this.date.toDate();
    selectedDate.setHours(0, 0, 0, 0);
    var futureDate = new Date(environment.LatestFutureBookingDate);
    futureDate.setHours(0, 0, 0);

    if (selectedDate > futureDate) {
      this.showUnavailableFutureDateMessage = true;
      this.showUnavailableFutureDateErrorMessage = environment.LatestFutureBookingDateErrorMessage.replace('#FacilityName#', this.facilitySummary.name);
      this.showUnavailableFutureDateErrorMessage = this.showUnavailableFutureDateErrorMessage.replace('#LatestFutureBookingDate#', moment(environment.LatestFutureBookingDate).format(environment.DateFormat.toUpperCase()).toString());
      this.isAvailable = false;
    }
    if (this.isEnableAutoAvailabilityCheck) {
      this.checkAvailability();
    }

    if (this.cartData && this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnBookingItemDateChange, this.getPackageDetail());
      const tempFacilitySummary: FacilitySummary[] = [];
      this.facilitySummary.availableTimeslots = [];
      tempFacilitySummary.push(this.facilitySummary);
      FacilityAdaptor.populateAvailableTimeslots(tempFacilitySummary, selectedDate, true);
    }
    this.changeTimeLineLoading = true
    this.changetimeline();

    this.itemUnavailableMessages = !this.isItemAvailable ? 'This item is not available for the selected Date' : undefined;

  }

  changetimeline(isItemChange: boolean = false) {

    //each facility wise calculate unavailable slots and populate main slot
    let _assetsLinkedToSelectedItem = this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem.itemAssets.map(s => s.asset?.id) : []
    let _fcArr = (_assetsLinkedToSelectedItem ?? []).length > 0 ? this.facilitySummary.multiPurposeAssets.filter(d => _assetsLinkedToSelectedItem.findIndex(f => f == d.id) >= 0) : this.facilitySummary.multiPurposeAssets;
    // let _fcArr = this.facilitySummary.multiPurposeAssets;
    //fcArr.push(this.facilitySummary);

    if (this.facilitySummary.selectedItem && (this.IsDateChangeFromCalendar || isItemChange)) {
      let dayStart = new Date(this.startTime);
      dayStart.setHours(0);
      dayStart.setMinutes(0);
      dayStart.setSeconds(0);

      let dayEnd = new Date(this.startTime);
      dayEnd.setHours(23);
      dayEnd.setMinutes(59);
      dayEnd.setSeconds(0);

      //this.facilitySummary.id
      this._bookingService.checkDiaryNote(dayStart, dayEnd, ({ hasUnavailableDilivaryNote, diaryNoteTimeSlot, unavailableVenueIds }) => {
        let availablityTimeSlotResult = this._assetService.timeslotSearch(_assetsLinkedToSelectedItem.join(','), this.getFormattedDate(dayStart), this.getFormattedDate(dayEnd));
        availablityTimeSlotResult.subscribe(async res => {
          this.changeTimeLineActiveRequests++
          this.facilitySummary.availableTimeslots = [];
          this.facilitySummary.calenderTimeslots = [];
          this.facilitySummary.timeslotLoaded = false;
          //validate on date change


          if (res) {

            _fcArr.forEach(f => {

              f.calenderTimeslots = [];
              f.availableTimeslots = [];
              f.timeslotLoaded = true;

              let _arr: Timeslot[] = res.filter(t => t.asset.id == f.id);
              var ts;
              if (unavailableVenueIds.length > 0 && unavailableVenueIds?.includes(f?.venue?.id)) {
                ts = FacilityAdaptor.populateMultipurposeTimeslot(
                  (diaryNoteTimeSlot),
                  this.date.toDate(),
                  f);
                this.hasDiaryNote = hasUnavailableDilivaryNote;
                this.isAvailable = hasUnavailableDilivaryNote ? false : true;
              } else {
                this.hasDiaryNote = false
                ts = FacilityAdaptor.populateMultipurposeTimeslot(
                  (_arr),
                  this.date.toDate(),
                  f);
              }
              //var ts = FacilityAdaptor.populateMultipurposeTimeslot(_arr, this.date.toDate(), f);
              if (ts) {
                ts.forEach(x => {
                  f.calenderTimeslots.push(x);
                });
              }

            });
            let hasAtLeastOneUnavailableVenue = false;
            _fcArr.forEach(facility => {
              if (hasUnavailableDilivaryNote && unavailableVenueIds.includes(facility?.venue?.id)) {
                facility.hasDiaryNote = true;
                hasAtLeastOneUnavailableVenue = true;
                this.isAvailable = hasUnavailableDilivaryNote ? false : true;
              } else {
                facility.hasDiaryNote = false;
              }
            });
            this.hasDiaryNote = hasAtLeastOneUnavailableVenue;
            //FacilityAdaptor.populateAvailableTimeslots(_fcArr, dayStart);


            _fcArr.forEach(x => {
              x.calendarTimeslotOriginal = [];
              x.calenderTimeslots.forEach(val => x.calendarTimeslotOriginal.push(Object.assign({}, val)));
            });
            //************************************************************************************* */
            //populate main multipurpose facility level availability
            //************************************************************************************* */

            /*FacilityAdaptor.populateMultiPurposeMainSpaceTimeslots(this.facilitySummary, this.date.toDate(), _fcArr);
            FacilityAdaptor.populateAvailableTimeslots([this.facilitySummary], dayStart, true);*/
            //************************************************************************************* */
            if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {

              let _validationOutPut = await this.CustomFunctionOnCalanderPopulate(_fcArr);
            }

            this.facilitySummary.availableTimeslots = [];

            //populate availability for each multi purpose assets
            FacilityAdaptor.populateAvailableTimeslots(_fcArr, dayStart, true);
            //this.facilitySummary: final slots will be updated to this
            //_fcArr this is the all assetes linked with this multi court with availble slots
            FacilityAdaptor.populateMultiPurposeMainSpaceTimeslots(this.facilitySummary, this.date.toDate(), _fcArr);
            //populate availability for each multi purpose asset(based on item selected)
            //this.facilitySummary have selected item related avaibility
            const { openingTime, closingTime } = FacilityAdaptor.getOpeningClosingTimes(this.facilitySummary, this.startTime);
            if ( openingTime && closingTime) {
              this.facilitySummary.openingTime = openingTime.toString();
              this.facilitySummary.closingTime = closingTime.toString();
            }
            const tempFacilitySummary: FacilitySummary[] = [];
            tempFacilitySummary.push(this.facilitySummary);
            FacilityAdaptor.populateAvailableTimeslots(tempFacilitySummary, dayStart, true);

            //this.facilitySummary = Object.assign({}, fcArr[0]);
            this.facilitySummary.timeslotLoaded = true;
            this.IsDateChangeFromCalendar = false;
          }
        },
          err => {
            console.log('Error', err);
            this.showUnavailableMessage = true;
            this.changeTimeLineLoading = false;
          }, () => {
            if (this.isEnableTimeLineAdvancedMode) {
              this.validateAvailability();
              this.drawSelectedTimeline();
              this.changeTimeLineActiveRequests--;
              if (this.changeTimeLineActiveRequests <= 0) {
                this.changeTimeLineLoading = false;
              }
            }
          }
        );
      })

    }

  }

  startTimeChanged() {
    this.timechange = true;
    if (!this.isEnableAutoAvailabilityCheck) {
      this.isAvailable = false;
    }
    if (this.startTime != null) {
      if (this.startChangedByTimeslotClick == 0) {
        var dtObj = Utility.roundToMinDuration(this.startTime, environment.MinimumBookingDuration);
        if (dtObj.isDateChanged) {
          this.startTime = moment(dtObj.newDate).toDate();
        }
      } else {
        this.startChangedByTimeslotClick--;
      }


      this.minEndDate = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();

      if (moment(this.startTime) >= moment(this.endTime)) {
        this.endTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();
      }

      var dt = this.date.toDate();
      var today = new Date();
      if ((dt.getFullYear() == today.getFullYear() && dt.getMonth() == today.getMonth() && dt.getDate() == today.getDate())) {
        if (this.startTime < today) {
          this.startTime = Utility.roundToMinDuration(new Date(), environment.MinimumBookingDuration).newDate;
        }
      }
      if (this.endTime.getFullYear() != this.startTime.getFullYear() ||
        this.endTime.getMonth() != this.startTime.getMonth() ||
        this.endTime.getDate() != this.startTime.getDate()) {
        this.endTime.setFullYear(this.startTime.getFullYear(), this.startTime.getMonth(), this.startTime.getDate());
      }
    }
    let startEndTime = this.getStartEndTime();
    this.validateNonOperationalHours(startEndTime.start, startEndTime.end);
    if (this.isEnableTimeLineAdvancedMode) {
      this.drawSelectedTimeline();
    }

    this.isStartTimeChanged = true;
    this.CallTimeChangeValidation();
  }

  endTimeChanged() {
    this.timechange = true;
    if (!this.isEnableAutoAvailabilityCheck) {
      this.isAvailable = false;
    }
    if (this.endTime != null) {
      if (this.endTime.getFullYear() == this.maxEndDate.getFullYear() &&
        this.endTime.getMonth() == this.maxEndDate.getMonth() &&
        this.endTime.getDate() == this.maxEndDate.getDate() &&
        this.endTime.getHours() == this.maxEndDate.getHours() &&
        this.endTime.getMinutes() == this.maxEndDate.getMinutes()) {
        this.endTime = moment(this.endTime).add(-1, 'm').toDate();
      } else {
        if (this.endChangedByTimeslotClick == 0) {
          var dtObj = Utility.roundToMinDuration(this.endTime, environment.MinimumBookingDuration, true);
          if (dtObj.isDateChanged) {
            this.endTime = moment(dtObj.newDate).toDate();
          }


        } else {
          this.endChangedByTimeslotClick--;
        }


        if (moment(this.startTime) >= moment(this.endTime)) {
          this.endTime = moment(this.startTime).add(environment.MinimumBookingDuration, 'm').toDate();
        }
      }
    }
    if (this.isEnableTimeLineAdvancedMode) {
      this.drawSelectedTimeline();
    }


    let startEndTime = this.getStartEndTime();
    this.validateNonOperationalHours(startEndTime.start, startEndTime.end);

    this.isStartTimeChanged = false;
    this.CallTimeChangeValidation();

    return this.endTime;
  }

  closeTimeMenu() {
    if (this.timechange) {
      if (this.isEnableAutoAvailabilityCheck) {
        this.checkAvailability();
        this.closeEndTimePopup();
      } else {
        let startEndTime = this.getStartEndTime();
        this.validateNonOperationalHours(startEndTime.start, startEndTime.end);
      }

      let itm = (this.facilitySummary.selectedItem ? this.facilitySummary.selectedItem : this.facilitySummary.item);

      // onchanging number of attendees if price typee cover
      if ((itm.itemMinPrice && itm.itemMinPrice.priceType.toLowerCase() == 'covers') || (itm.itemMaxPrice && itm.itemMaxPrice.priceType.toLowerCase() == 'covers')) {
        this.facilitySummary.attendees = this.attendees;
      }
      this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));
      this.timechange = false;

    } else {
      this.closeEndTimePopup();
    }
  }

  //display recive message
  receiveConfigurationMessage(event) {
    this.selectedConfiguration = { id: "", name: "" };
    this.selectedConfiguration.name = event;
    //configuration match with selected configuration name
    let _configs = this.allConfigurations.filter(c => c.name == event);
    //filter item for the selected configuration
    this.matchingItems = this.activityMatchingItems.filter(i => i.itemAssets.findIndex((s: ItemAssets) => {
      return _configs.findIndex((h: Configuration) => {
        return h.id == s.configuration?.id
      }) >= 0
    }) >= 0);
    if (this.isConfigurationEnabled) {
      this.getImagesforConfigurations();
    }
    this.clearSelection()

  }
  //this.onConfigurationChange(this.uniqueConfigurationNames.find(c => c.name == this.selectedConfiguration.name))

  /*let cnf = this.getSelectedConfiguration();
 let newCnf = this.allConfigurations.find(f => f.name == event);
 this.facilitySummary.selectedConfiguration = newCnf;
 if (cnf.setupTime != newCnf.setupTime || cnf.teardownTime != newCnf.teardownTime) {
   if (this.isEnableAutoAvailabilityCheck) {
     this.checkAvailability();
   }
   this.drawSelectedTimeline();
 } */

  // start time end time click event
  setStartEndTime(slot) {
    const startTimeSlot = Utility.convertISOToDate(slot.startTime);
    const endTimeSlot = Utility.convertISOToDate(slot.endTime);
    this.startChangedByTimeslotClick++;
    this.startTime = startTimeSlot;
    this.endChangedByTimeslotClick++;
    this.endTime = endTimeSlot;

    //time and date initialize
    // this.initializeTime();
    //this.isAvailable = true;
    //this.showUnavailableMessage = false;

    if (this.isEnableAutoAvailabilityCheck) {
      this.checkAvailability();
    }


  }

  openAlternativeOptions(): void {
    //console.log(facility);
    this.facilitySummary.startTime = this.getFormattedDate(this.startTime);
    this.facilitySummary.endTime = this.getFormattedDate(this.endTime);

    const dialogRef = this.dialog.open(AlternativeOptionsComponent, {
      data: { fc: this.facilitySummary },
      panelClass: ['w80modal', 'dialog-container-common'],
      width: '250px'
    });
  }

  getImagesforConfigurations() {
    let configurationWithNoImage = [];
    if (this.facilitySummary.configurations != undefined && this.facilitySummary.configurations.length > 0) {
      this.facilitySummary.configurations.forEach((c, i) => {
        let configuration = c as Configuration;
        if (configuration.configurationThumbnail == undefined && configuration.type != undefined) {
          configurationWithNoImage.push({
            id: configuration.id,
            type: configuration.type,
            configurationCategoryId: configuration.configurationCategoryId
          });
        }
      });

      if (configurationWithNoImage.length > 0) {
        let result = this._assetService.getConfigurationImages(configurationWithNoImage);
        result.safeSubscribe(this, data => {

          data.forEach((c, i) => {
            let index = this.facilitySummary.configurations.findIndex(x => x.id == c.id);
            if (index > -1) {
              this.facilitySummary.configurations[index].configurationThumbnail = (c.isLocalUrl) ? environment.ApiUrl + c.url : c.url;
            }
          });
        });
      }

    }
  }


  closeStartTimePopup() {
    this.starttrigger.closeMenu();
  }

  closeEndTimePopup() {
    this.endtrigger.closeMenu();
  }

  setAvailableSlots(slots: CalenderTimeslot[]) {
    this.availableSlots = slots;
  }

  drawSelectedTimeline() {
    let searchdate = new Date(this.date.year(), this.date.month(), this.date.date());
    let selectedStart = Utility.appendTimePart(searchdate, Utility.convertISOToDate(this.startTime), true);
    let selectedEnd = Utility.appendTimePart(searchdate, Utility.convertISOToDate(this.endTime), true);
    FacilityAdaptor.populateSelectedTimeslot(this.facilitySummary, selectedStart, selectedEnd, this.getSelectedConfiguration());
  }

  getFacilityName(facility) {
    if (facility.name != undefined && facility.item.name != undefined) {
      if (facility.name == facility.item.name) {
        return facility.item.name;
      }
      return (facility.name + ' : ' + facility.item.name);
    }
  }

  getTimeslotAvailabilityHeader() {
    var checkTimeSlots = this.availableSlots.length;
    if (checkTimeSlots == 0) {
      return 'No time slots are available';
    }
    return 'Available time slots';

  }

  getBumpInOutNotification() {

    if (this.displayBumpInOutNotification) {
      //undefined check
      var configuration = (this.facilitySummary.selectedConfiguration != undefined) ? (this.facilitySummary.selectedConfiguration) : (this.facilitySummary.configuration);
      var SetupTime = (configuration && configuration.setupTime != null) ? (configuration.setupTime) : 0;
      var teardownTime = (configuration && configuration.teardownTime != null) ? (configuration.teardownTime) : 0;
      //null check
      if (SetupTime == 0 && teardownTime == 0) {
        return;
      }
      if (SetupTime == 0 || teardownTime == 0) {
        var returnDisplayBumpInOutValue = (SetupTime != 0 && teardownTime == 0) ?
          ("This venue has a setup time of " + SetupTime + " minutes")
          : (SetupTime == 0 && teardownTime != 0) ? ("This venue has a  tear down time of " + teardownTime + " minutes") : "";
        return returnDisplayBumpInOutValue;
      }
      if (SetupTime == teardownTime) {
        return ('This venue has a setup and tear down time of ' + SetupTime + ' minutes');
      }
      return ('This venue has a setup time of ' + SetupTime + ' minutes and tear down time of ' + teardownTime + ' minutes');

    }
    return;
  }

  isFacilityAndItemNameSame() {
    let _itemName = '';
    if (this.facilitySummary) {
      if (this.getItem().name) {
        _itemName = this.getItem().name.trim();
      }
    }
    return this.facilitySummary.name.trim() == _itemName;
    return false;
  }

  getItem() {
    if (this.facilitySummary) {
      var selectedItem = this.facilitySummary.selectedItem;
      if (selectedItem == undefined) {
        selectedItem = this.facilitySummary.item;
      }
      return selectedItem;
    }
    return;
  }

  getConfigurationData() {
    return this.uniqueConfigurationNames
    /*  var selectedItem = this.getItem();
     if (selectedItem && this.checkAllassertsAreLoaded()) {
       this.onGetFilterdConfiguration();
       return this.filterConfigurations;
     } */
  }

  getSelectedConfiguration() {
    if (this.facilitySummary) {//&& this.checkAllassertsAreLoaded()
      let selectedconfiguration = FacilityAdaptor.getAdapterSelectedConfiguration(this.facilitySummary)
      return selectedconfiguration
    }
  }

  isBumpinOutIncluded() {
    var cnf = this.getSelectedConfiguration();
    return cnf.setupTime > 0 || cnf.teardownTime > 0;
  }

  estimatedPriceRange(facility) {
    let itm = this.getItem();
    return BookingAdaptor.isRange(itm.calculatedMinPrice, itm.calculatedMaxPrice);
  }

  getEstimatedPrice(facility) {
    let itm = this.getItem();
    var prc = BookingAdaptor.getItemPrice(itm, 1);
    if (prc) {
      return prc.priceIncludingTax;
    }
  }

  isHaveEstimatedPrice(facility) {
    let price = this.getEstimatedPrice(facility);
    return (price > -1);
  }

  public attendeesIsValid() {
    try {
      var cnf = this.getSelectedConfiguration();
      if (cnf.capacity && cnf.capacity != null) {
        return (cnf.capacity >= this.attendees);
      }
    } catch (e) {
      return false;
    }
  }

  public attendeesCountIsValid() {
    try {
      return (this.attendees != null && this.attendees != 0 && (!isNaN(this.attendees)));
    } catch (e) {
      return false;
    }
  }

  isBookable() {
    let val = !this.hasDiaryNote &&
      this.isAvailable &&
      this.attendeesIsValid() &&
      this.attendeesCountIsValid() &&
      !this.isBookingLeadDaysError &&
      this.isHaveEstimatedPrice(this.facilitySummary) &&
      this.isHavingValidMinTime() &&
      this.isItemAvailable &&
      !this.showUnavailableOperationalMessage &&
      !this.isSestemLoading();
    return val;
  }

  showItemsAvailability(facility) {
    if (facility.items != undefined && this.isConfigurationEnabled == true) {
      if (facility.items.length > 0) {
        return true;
      }
    }
    return false;
  }

  isUnitPriceRange(item) {
    if (item == undefined) {
      return false;
    }

    item.itemMinPrice = (item.itemMinPrice) ? item.itemMinPrice : item.itemMaxPrice;
    item.itemMaxPrice = (item.itemMaxPrice) ? item.itemMaxPrice : item.itemMinPrice;
    if (item.itemMinPrice == undefined || item.itemMaxPrice == undefined) {
      return false;
    }

    var min = (item.itemMinPrice) ? item.itemMinPrice!.priceIncludingTax : 0;
    var max = (item.itemMaxPrice) ? item.itemMaxPrice!.priceIncludingTax : 0;

    var dp: DecimalPipe = new DecimalPipe('en');
    return dp.transform(min, '1.2-2') != dp.transform(max, '1.2-2');
  }
  /*isSlotAvailable(fcs: FacilitySummary) {
    return fcs.availableTimeslots.findIndex(t => {
      t.startTime <= this.startTime && t.endTime >= this.endTime
    }) >= 0 && this.validateAvailabilityWithinSameBooking(fcs);
  }*/
  isSlotAvailable(fcs: FacilitySummary) {
    return fcs.availableTimeslots.findIndex(t => {
      const condition = t.startTime <= this.startTime && t.endTime >= this.endTime;
      return condition;
    }) >= 0 && this.validateAvailabilityWithinSameBooking(fcs);
  }
  getFirstAvailableFacility(item: Item) {
    //TODO within cart items check assset get overlap
    let _fc = null;
    item.itemAssets.sort((a, b) => {
      return a.preference - b.preference;
    });

    /*item.itemAssets.forEach((ist: ItemAssets) => {
      if (_fc == null) {
        let return_fc = this.facilitySummary.multiPurposeAssets.find(a => a.id == ist.asset.id);
        if (return_fc && this.isSlotAvailable(return_fc)) {
          _fc = return_fc
        }
      }
    })

    return _fc;*/

    for (const ist of item.itemAssets) {
      if (_fc == null) {
        let return_fc = this.facilitySummary.multiPurposeAssets.find(
          a => a.id === ist.asset.id
        );
        if (return_fc && !this.addedFacilityIDs.has(return_fc.id) && this.isSlotAvailable(return_fc)) {
          _fc = return_fc;
          break;
        }
      }
    }

    return _fc;
  }


  getConfigurationBasedOnItemAndConfiguration(item: Item) {
    if (item.itemAssets != undefined) {
      let _facilityToBook = item.allocateToAllAssets ? item.itemAssets[0].asset?.id : (this.getFirstAvailableFacility(item) != null) ? this.getFirstAvailableFacility(item).id : '';

      let itmAsset = item.itemAssets.find(a => a.asset.id == _facilityToBook);
      if (itmAsset) {
        if (itmAsset.configuration != undefined && itmAsset.configuration.id != null) {
          return this.allConfigurations.find(c => c.id == itmAsset.configuration.id)
        }
      }
    }

    return null;
  }
  getAllocationInfo(item: Item): ItemAssets[] {
    if (item.itemAssets != undefined) {
      if (item.allocateToAllAssets) {
        return item.itemAssets
      } else {
        let _facilityToBook = this.getFirstAvailableFacility(item);
        let _configurationMatched = this.allConfigurations.filter(c => c.name == this.selectedConfiguration.name)
        let itmAsset = item.itemAssets.find(a => a.asset.id == _facilityToBook?.id && _configurationMatched.findIndex((c: Configuration) => {
          return c.id == a.configuration.id
        }) >= 0);
        if (itmAsset) {
          return [itmAsset]
        }
      }

    }

    return null;
  }


  async addToBookingAlternative(item) {
    this.facilitySummary.selectedItem = item;
    this.selectedItemId = item.id;
    this.facilitySummary.selectedConfiguration = this.getConfigurationBasedOnItemAndConfiguration(item);
    this.facilitySummary.ItemAssetsToBook = this.getAllocationInfo(item);

    // this.facilitySummary.selectedConfiguration = FacilityAdaptor.getConfiguration(this.facilitySummary.selectedItem, this.facilitySummary);
    this.calculateItemPrices([this.facilitySummary], this.getFormattedDate(this.startTime), this.getFormattedDate(this.endTime));

    /*   let spaceItem = new SpaceItem();
      spaceItem.selectedItem = item;
      this.store.dispatch(new SetMultiPurposeSpaceItem(spaceItem)); */
    this.setItemRemainingLeadDaysList(this.startTime, this.facilitySummary.items)
    let _validationOutPut;
    if (this.cartData && this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnChangeItem, this.packageDetail);
    }

    this.itemUnavailableMessages = !this.isItemAvailable ? 'This item is not available for the selected Date' : undefined;
    this.changeTimeLineLoading = true
    this.changetimeline(true)
  }

  async CallCustomFunction(facilitySummary, action, packageDetails, exsitingfacilitySummaries = []) {
    let _validationOutPut;

    let _formData = {
      attendees: this.attendees,
      startTime: this.startTime,
      endTime: this.endTime,
      date: this.date,
      selectedConfiguration: this.facilitySummary.selectedConfiguration,
      configuration: this.facilitySummary.configuration,
      selectedItem: this.facilitySummary.selectedItem,
      isStartTime: this.isStartTimeChanged
    };

    let _options = {
      preliminaryAsUnavailable: this.AppData.BookingConfig.CheckAvailability.DisplayPreliminarySlotAsUnavailble
    };

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(
        x => x.customFunctionAction.action == action
      );

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {
        this.customFunctionActiveRequests++;
        this.loading = true;

        try {
          _validationOutPut = await window[_validateFunction.functionName](
            facilitySummary, _formData, _options, packageDetails, exsitingfacilitySummaries
          );

          this.errorMessages = [];
          this.warningMessages = [];

          if (_validationOutPut?.Messages?.length > 0) {
            _validationOutPut.Messages.forEach(er => {
              if (er.ErrorType == ErrorType.Error) {
                this.errorMessages.push(er.Detail);
              }
              if (er.ErrorType == ErrorType.Warning) {
                this.warningMessages.push(er.Detail);
              }
            });
          }

          this.continueProcess = !!(_validationOutPut && _validationOutPut.ContinueProcess);

          if (_validationOutPut) {
            this.checkAvailability(); // ✅ make sure this is awaited
          }
        } catch (err) {
          console.error("Error in CallCustomFunction:", err);
          this.continueProcess = false;
        } finally {
          this.customFunctionActiveRequests--;
          if (this.customFunctionActiveRequests <= 0) {
            this.loading = false;
          }
        }
      }
    }

    return _validationOutPut;
  }

  async CustomFunctionOnCalanderPopulate(facilityArray) {
    let _validationOutPut;

    let _options = {

      preliminaryAsUnavailable: this.AppData.BookingConfig.CheckAvailability.DisplayPreliminarySlotAsUnavailble

    };

    let _formData = {
      attendees: this.attendees,
      startTime: this.startTime,
      endTime: this.endTime,
      date: this.date

    };

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(x => (x.customFunctionAction.action == Action.OnPopulateUnavailableCalenderSlots));

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {

        _validationOutPut = await window[_validateFunction.functionName](facilityArray, _options, _formData);

      }
    }

    return _validationOutPut;

  }

  packageSelectorChange(selectedPackage: BespokePackage = null, attendees?: number) {

    if (selectedPackage) {
      this.packageFilter.PackageDetail = selectedPackage;
    }
    if (this.packageFilter && this.packageFilter.PackageDetail && this.packageFilter.PackageDetail.packageItems && this.packageFilter.PackageDetail.packageItems.length > 0) {
      let resultCal = this._packageService.CalculatePackagePrices(Utility.convertToISO(Utility.convertISOToDate(this.startTime)), Utility.convertToISO(Utility.convertISOToDate(this.endTime)), this.attendees, selectedPackage.id);
      resultCal.safeSubscribe(this, (result) => {
        if (result != null) {
          let filter = this.getPackageFilter();
          if (result.packageItems) {
            filter.PackageDetail.packageItems = result.packageItems;
            if (attendees != null) {
              filter.Attendees = attendees;
            }
          }
          this.store.dispatch(new UpdateBookingPackage(filter));
        }

      },
        err => {
          console.log('Error : calculatePackagePrice ', err);
        }
      );
    } else {
      let filter = this.getPackageFilter();
      this.store.dispatch(new UpdateBookingPackage(filter));
      //this.showPackageIncludes();
    }

    this.CallPackageChangeValidation();

  }

  getPackageFilter() {
    let filter = this.packageFilter;
    filter.BussinessAreaId = +this.selectedBusinessArea;
    filter.PackageClass = this.selectedClass;
    filter.Package = +this.selectedPackage;
    //filter.PackageDetail = result.packageItems;
    //  filter.snackBar = this.snackBar;
    filter.EventName = this.defaultEventName;
    // filter.ledgerNumber = this.ledgerNumber;
    filter.StartTime = this.minDate;
    filter.EndTime = this.maxDate;
    //filter.Attendees = this.maxattendees;
    return filter;
  }

  selectPackageList() {
    let selectedFaclities = Object.assign([], this.facilitySummaries);

    if (!selectedFaclities || selectedFaclities.length == 0) {
      selectedFaclities = [this.facilitySummary];
    } else {
      selectedFaclities.push(this.facilitySummary);
    }

    let filterdPackages = [];
    let packageFilterdByClass = this.packages.filter(a => a.packageClassId == +this.selectedClass);

    if (packageFilterdByClass.length == 0) {
      this.selectedPackage = null;
      this.selectedPackageDetail = null;
      if (this.packageDetail) {
        this.packageFilter.PackageDetail = null;
        let _filter = this.getPackageFilter();
        this.store.dispatch(new UpdateBookingPackage(_filter));
      }
      this.setPackageRemainingLeadDaysList(this.startTime, filterdPackages)
      return filterdPackages;
    }

    filterdPackages = this.getfilterPackagesBySalesCategory(packageFilterdByClass, selectedFaclities);
    this.setPackageRemainingLeadDaysList(this.startTime, filterdPackages)
    return filterdPackages;
  }

  clearSelection() {
    this.facilitySummary.selectedItem = null;
    this.selectedItemId = null;
    this.facilitySummary.selectedConfiguration = null;
    this.facilitySummary.ItemAssetsToBook = [];
    // this.facilitySummary = { ...this.facilitySummary, selectedItem: { ...this.facilitySummary.selectedItem } }
    //to reset selected item
    this.matchingItems = [...this.matchingItems]
  }

  async packageChange() {
    this.clearSelection()
    this.onGetFilterdItemsBySelectedActivity(this.selectedPackage)
    if (this.selectedPackage == '') {
      this.selectedPackage = null;
      this.selectedPackageDetail = null;
      this.isValidPackage = false;
      this.packageSelectorChange();
    } else {
      let selectedPackage = this.packages.find(p => p.id == this.selectedPackage);
      if (selectedPackage) {
        this.packageSelectorChange(selectedPackage);
      }
      if (this.facilitySummaries && this.facilitySummaries.length > (this.isAddFacility ? 0 : 1)) {
        if (this.getPackageDetail() && this.getPackageDetail().id != this.selectedPackage) {
          let dialogRef = this.dialog.open(DeleteConfirmationComponent, {
            data: {
              message: 'Please note that, if you change the event it will be applied to the other facilities in the booking cart. Do you want to proceed?',
              yesText: 'YES',
              noText: 'NO'
            },
            panelClass: ['custom-dialog-container', 'w30modal'],
            height: 'auto',
            width: '30%'
          });

          const sub = dialogRef.componentInstance.onAdd.subscribe(async (data: any) => {
            if (data == true) { // yes click
              this.isValidPackage = this.packageSeletedValidation();
              if (this.cartData.addedFacilites) {
                let _validationOutPut;
                if (this.cartData?.userDefinedFunctions && this.cartData?.userDefinedFunctions.length > 0) {
                  _validationOutPut = await this.CallCustomFunctionForChangePackageOnCart(undefined, Action.OnPackageChange, this.packageSelected)
                }

                if (_validationOutPut && _validationOutPut.ContinueProcess == true) {
                  for (const fc of this.facilitySummaries) {
                    this.calculateItemPrices([fc], fc.startTime, fc.endTime);
                  }

                }

              }
            } else {
              let _prevSelectedPackage = this.getPackageDetail();
              this.selectedPackage = _prevSelectedPackage ? _prevSelectedPackage.id : null;
            }
            this.questionValidation();

          });
        } else {
          this.isValidPackage = this.packageSeletedValidation();
        }
      } else {
        this.isValidPackage = this.packageSeletedValidation();
        this.questionValidation();

      }
    }
    //this.showPackageIncludes();
  }


  questionValidation() {
    if (this.packageFilter.PackageDetail && this.packageFilter.PackageDetail.question && this.packageFilter.PackageDetail.question.length > 0) {
      // this.store.dispatch(new QuestionPopupShown());
      this.isShowQuestionsUpdate = true;
    } else {
      // this.store.dispatch(new QuestionPopupHidden());
      this.isShowQuestionsUpdate = false;
    }
  }


  updateQuestionPopupState() {
    if (this.isShowQuestionsUpdate) {
      this.store.dispatch(new PackageQuestionPopupShown());
    } else {
      this.store.dispatch(new PackageQuestionPopupHidden());
    }
  }


  packageSeletedValidation() {
    let selectedFaclities = Object.assign([], this.facilitySummaries);

    if (!selectedFaclities || selectedFaclities.length == 0) {
      selectedFaclities = [this.facilitySummary];
    } else {
      selectedFaclities.push(this.facilitySummary);
    }

    if (this.selectedPackage == undefined || this.selectedPackage == null) {
      this.snackBar.openFromComponent(AlertMessageComponent, {
        duration: 3000,
        verticalPosition: 'top',
        data: ['Please select the event']
      });
      return false;
    }


    let selectedPackage = this.packages.find(p => p.id == this.selectedPackage);
    this.showPackageLevelLeadDaywarnigMessage(this.selectedPackage);
    if (!this.packageSelected || this.packageSelected.id != selectedPackage.id) {
      if (this.selectedPackageDetail != null) {
        if (this.selectedPackageDetail.id == selectedPackage.id) {
          this.packageSelected = this.selectedPackageDetail;
        } else {
          this.packageSelected = selectedPackage;
        }
      } else {
        this.packageSelected = selectedPackage;
      }

    }
    let isMatch = true;
    if (this.facilitySummary.selectedItem != null) {
      if (selectedPackage) {
        selectedFaclities?.forEach(function (fc: FacilitySummary) {
          if (isMatch) {
            let _item = fc.selectedItem != null ? fc.selectedItem : fc.item;
            let index = selectedPackage?.salesCategories?.findIndex(sc => _item?.salesCategories?.findIndex(isc => isc.id == sc) >= 0);
            if (!(index != undefined && index >= 0)) {
              isMatch = false;
            }
          }
        });
        if (!isMatch) {
          this.snackBar.openFromComponent(AlertMessageComponent, {
            duration: 3000,
            verticalPosition: 'top',
            data: ['Selected event is not matched with selected facilities']
          });
        } else {

          if (this.selectedPackageDetail == null) {
            this.selectedPackageDetail = this.packages.find(p => p.id == this.selectedPackage);
          }
          this.packageSelectorChange(this.packageSelected);
        }
      } else {
        this.snackBar.openFromComponent(AlertMessageComponent, {
          duration: 3000,
          verticalPosition: 'top',
          data: ['Selected event is not matched with selected facilities']
        });
        isMatch = false;
      }

      if (this.packageSelected.originalQuestion && this.packageSelected.originalQuestion != null) {
        var appSetting = environment.AppSetting as AppSetting;
        let statusFilterRaw = appSetting?.BookingConfig?.BookingStatusForQuestions ?? "";
        let statusList = [];
        let approveStatusList = [];

        statusList = statusFilterRaw != null && statusFilterRaw != ""
          ? statusFilterRaw?.split(',').map(s => s.trim())
          : [String(environment.BookingStatus)];

        let approveStatusRaw = appSetting?.BookingConfig?.BookingStatusForImmediateBookingQuestions ?? "";
        approveStatusList = approveStatusRaw != null && approveStatusRaw != ""
          ? approveStatusRaw.split(',').map(s => s.trim())
          : [String(environment.BookingApproveStatus)];


        this.packageSelected.question = this.packageSelected.originalQuestion
          .filter(pq => statusList?.includes(pq.bookingStatusId) ||
            (this.isAllImmediateConfirmed && approveStatusList?.includes(pq.bookingStatusId)));

        if(this.packageSelected?.question && this.packageSelected?.question?.length > 0){
          this.packageSelected.question.sort((a, b) => (a?.questionNo ?? 0) - (b?.questionNo ?? 0));
        }

        if (this.packageSelected.question.length > 0 && isMatch && this.answeredCurrentCount(this.packageSelected.question) == this.packageSelected.question.length) {
          this.packageFilter.PackageDetail = this.packageSelected;

        }
      }
    }


    return isMatch;
  }

  isHavingValidMinTime() {
    let status = true;
    if (this.isCategoryAndEventEnabled) {
      if (this.isCategoryAndEventMandatory) {
        if ((+(this.selectedPackage ? this.selectedPackage : 0)) > 0) {
          status = true;
        } else {
          status = false;
        }

      } else {
        status = true;
      }
    } else {
      status = true;
    }

    if (!this.isContinueProcessOnpackageChange && !this.errorMessages) {
      status = false;
    }

    if (!this.isContinueProcessOnTimeChange && !this.errorMessages) {
      status = false;
    }

    return status;
  }

  async CallPackageChangeValidation() {
    let _validationOutPut;
    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnPackageChange, this.getPackageDetail());
    }

    if (_validationOutPut && _validationOutPut.ContinueProcess == false) {
      this.isContinueProcessOnpackageChange = false;
    } else {
      this.isContinueProcessOnpackageChange = true;
    }
  }

  getPackageDetail() {
    return this.packageFilter?.Package > 0 ? this.packageFilter?.PackageDetail : undefined;
  }

  async CallTimeChangeValidation() {
    let _validationOutPut;
    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      _validationOutPut = await this.CallCustomFunction(this.facilitySummary, Action.OnTimeChange, this.getPackageDetail());
    }

    if (_validationOutPut && _validationOutPut.ContinueProcess == false) {
      this.isContinueProcessOnTimeChange = false;
    } else {
      this.isContinueProcessOnTimeChange = true;
    }
  }

  validatePackageClass(state) {
    let matchingPackages = FacilityAdaptor.getMatchedPackages([this.facilitySummary], state.bespokePackages);
    if (state.packageFilter !== undefined && state.packageFilter != null) {
      if (matchingPackages.length > 0) {

        let distinctPC = matchingPackages.map(p => p.packageClassId).filter((age, index, arr) => arr.indexOf(age) == index);
        state.packageFilter.FilteredPackageClasses = environment.PackageClasses.filter(cls => cls.Id != '0' && distinctPC.indexOf(cls.Id) >= 0);
        if (!state.packageFilter.Package || matchingPackages.findIndex(selectedP => selectedP.id == state.packageFilter.Package) < 0) {
          state.packageFilter.PackageClass = matchingPackages[0].packageClassId;
          state.packageFilter.BussinessAreaId = matchingPackages[0].businessAreaId;
        }
      } else {
        state.packageFilter.Package = 0;
      }
    }


  }


  answeredCurrentCount(question) {
    var count = 0;
    for (var q of question) {
      if ((q.type == 'textQuestion' || q.type == 'booleanQuestion' || q.type == 'singleChoiceQuestion') && (q.answeredText != undefined && q.answeredText != null && q.answeredText != '')) {
        count++;
      } else if (q.type == 'multipleChoiceQuestion') {
        var answeredCount = 0;
        if (q.answerChoices) {
          q.answerChoices.forEach((answ, indx) => {
            if (q.quantityRequired) {
              if (answ.Quantity) {
                answeredCount++;
              }
            } else {
              if (answ.isSelectedAnswer) {
                answeredCount++;
              }
            }
          });
          if (answeredCount > 0) {
            count++;
          }
        }
      }
    }
    return (question.length) - count;
  }


  getfilterPackagesBySalesCategory(packages: BespokePackage[], selectedFaclities: FacilitySummary[]) {
    let filterdPackages = [];
    if (packages.length) {
      packages.forEach(function (pk) {
        let isMatch = false;
        selectedFaclities.forEach(function (fc) {
          if (!isMatch) {
            if (pk.salesCategories != undefined) {
              /* let _item;
              // high priority for selected item in absence of selected item itme is chosen
              if (fc.selectedItem) {
                _item = fc.selectedItem;
              } else if (fc.item) {
                _item = fc.item;
              } */

              fc.items.forEach(_item => {
                if (!isMatch) {
                  var index = pk.salesCategories.findIndex(sc => _item && _item.salesCategories && _item.salesCategories.length > 0 && _item.salesCategories.findIndex(isc => isc.id == sc) >= 0);
                  if ((index != undefined && index >= 0)) {
                    isMatch = true;
                  }
                }
              });


            } else {
              isMatch = false;
            }
          }
        });


        if (isMatch) {
          filterdPackages.push(pk);
        }
      });
    }


    return filterdPackages;
  }

  isPackageSelected() {
    return (this.selectedPackage == undefined || this.selectedPackage == null) ? false : true;
  }

  get isItemAvailable() {

    let isAvailable = true;
    // high priority for selected item in absence of selected item itme is chosen
    if (this.facilitySummary) {
      let _item = this.facilitySummary.selectedItem ?
        this.facilitySummary.selectedItem : this.facilitySummary.item ?
          this.facilitySummary.item : null;
      if (_item) {
        isAvailable = (_item.availableTo && new Date(_item.availableTo) < new Date(this.endTime)) ? false : true;
      }

    }
    return isAvailable;
  }


  /*********************************************************************************************************************/

  async getCombinedRoomFacilities() {
    if ((this.facilitySummary?.multiPurposeIds ?? "") != "") {
      let searchParam = new Assetsearchparams();
      searchParam.assetIds = this.facilitySummary?.multiPurposeIds ?? "";
      var _res = await this._assetService.facilittySearch(searchParam, null, true).toPromise();
      this.facilitySummary.multiPurposeAssets = _res.facilities;
      // searchParam.filterattendens = '0';
      // if (this.searchFacilities.length == 0 && this.itemidlist.length == 0) {
      /* this._assetService.facilittySearch(searchParam, null, true).safeSubscribe(this, (data) => {
         this.facilitySummary.multiPurposeAssets = data.facilities;

          this.searchFacilities = [...data.facilities];
         this.itemidlist = data.itemList;
         this.getAllMultipurposeFacilityCogigurations();
         this.searchItem();
       });*/
      //}
      /* else{
        this.getAllMultipurposeFacilityCogigurations();
        this.searchItem();
      } */
    }
  }
  /* checkAllassertsAreLoaded(): boolean {
    let loaded = false;
    if (this.searchFacilities != undefined && this.searchFacilities.length > 0) {
      loaded = true;
    }
    return loaded
  }
    getAllMultipurposeFacilityConfigurations() {
      if (this.searchFacilities != undefined && this.searchFacilities.length > 0) {
        let configurationList: any[] = [];

        this.searchFacilities.forEach((facility: FacilitySummary) => {
          if (facility.configurations) {
            configurationList.push(...facility.configurations);
          }
        });
        if (configurationList.length > 0) {
          // this.facilitySummary.configurations = configurationList;
        }
      }
    } */

  /*searchItem() {
    if (this.itemidlist.length > 0) {
      let itemsearch = new ItemSearchParams();
      itemsearch.ItemTypeid = 1;

      itemsearch.itemidlist = this.itemidlist;
      itemsearch.FromDate = this.data.facility.startTime;
      itemsearch.Todate = this.data.facility.endTime;
      itemsearch.salesChannelId = environment.SalesChannel;

      this.store.dispatch(new FacilitySearchLoading());
      this.itemSubcription = this._itemService.itemSearch(itemsearch).safeSubscribe(this, (data) => {
        this.cart_subscriber = this.cart$.safeSubscribe(this, cart => {
          this.selectedClass = (cart.packageFilter != undefined && cart.packageFilter != null && !isNaN(cart.packageFilter.PackageClass)) ? cart.packageFilter.PackageClass : environment.DefaultPackageClassId;
          FacilityAdaptor.PopulateFacilitySummary(this.searchFacilities, data, this.selectedClass,
            FacilityAdaptor.getBookingPriceConcession(this.customerDefaultPriceConsessionId, false), 0);

          this.onGetfilterActivityUsingItems(this.packages, data)
          this.onGetFilterdConfiguration();
        });
      }, error => {

      }, () => {
        this.store.dispatch(new FacilitySearchLoaded());

      });
    }
  }

  onGetfilterActivityUsingItems(packages: BespokePackage[], items: Item[]) {
    let filterdPackages = new Array<BespokePackage>();
    if (packages.length > 0 && items.length > 0) {
      let allSalesCategories: SalesCategory[] =
        items.reduce((acc, item) => acc.concat(item.salesCategories || []), []);
      let uniqueSalesCategories: SalesCategory[] = [];
      if (allSalesCategories.length > 0) {
        uniqueSalesCategories = Array.from(
          new Map(allSalesCategories.map((item) => [item.id, item])).values()
        );
      }
      packages.forEach(function (pkg) {
        let isMatch = true;
        if (pkg.salesCategories && uniqueSalesCategories) {
          var index = pkg.salesCategories.findIndex(
            (sc) =>
              uniqueSalesCategories.findIndex((isc) => isc.id == sc) >= 0
          );

          if (!(index != undefined && index >= 0)) {
            isMatch = false;
          }

          if (isMatch) {
            filterdPackages.push(pkg);
          }
        }
      });
    }
    this.filteredPackages = filterdPackages;
  }*/

  onGetFilterdItemsBySelectedActivity(selectedPackageId: string = "") {
    if (selectedPackageId != "") {
      let selectedPackage = this.packages.find(p => p.id == selectedPackageId);
      if (!selectedPackage?.salesCategories || !this.facilitySummary?.items) {
        return [];
      }
      const selectedSalesCategoryIds = new Set(
        selectedPackage.salesCategories.map((sc) => sc)
      );
      const matchingItems = this.facilitySummary.items
        .filter(item =>
          item.salesCategories.some(sc => selectedSalesCategoryIds.has(sc.id))
        )
        .sort((a, b) => {
          const normalize = (str: string) => str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
          return normalize(a.name).localeCompare(normalize(b.name));
        });

      this.matchingItems = matchingItems;
      this.activityMatchingItems = [...matchingItems]
    } else {
      this.matchingItems = [];
      this.activityMatchingItems = []
    }
    /*  else {
       this.matchingItems = this.facilitySummary.items;
     } */

    if (this.matchingItems != null && this.matchingItems.length > 0) {
      /*if(!this.onCheckMacthingItemisAlreadySelected()){
        this.facilitySummary.selectedItem = this.matchingItems[0];
      }*/
    }
    this.onGetFilterdConfiguration();
  }

  onCheckMacthingItemisAlreadySelected(): boolean {
    if (!this.matchingItems || !this.facilitySummary?.selectedItem) {
      return false;
    }
    return this.matchingItems.some(
      (item) => item.id == this.facilitySummary.selectedItem.id
    );
  }



  onGetFilterdConfiguration() {
    let filteredConfigurations: Configuration[] = [];
    if (this.matchingItems.length > 0) {
      this.matchingItems.forEach(mi => {
        let _configs = mi.itemAssets.reduce((cnList, cn) => {
          let _config = this.allConfigurations.filter(s => s.id == cn.configuration?.id);
          if (_config?.length > 0) {
            cnList.push(_config[0]); // Flatten the array
          }
          return cnList
        }, [])

        _configs.forEach(c => {
          filteredConfigurations.push(c)
        })
      })

      this.filterConfigurations = filteredConfigurations;
      this.uniqueConfigurationNames = [...new Set(filteredConfigurations.map(s => s.name))].map(d => {
        return { id: d, name: d }
      })
    }
    this.selectedConfiguration = null;

    if (
      !this.isAddFacility &&
      this.uniqueConfigurationNames.length > 0 &&
      this.facilitySummary?.selectedConfiguration != null &&
      this.facilitySummary?.selectedItem != null
    ) {
      this.populateCartData()
    }
    /*
    let configurations = this.searchFacilities
      .map(asset => asset.configurations ?? [])
      .reduce((acc, val) => acc.concat(val), []);

    if (this.selectedPackage && configurations.length > 0) {
      if (this.searchFacilities.length > 0 && configurations.length > 0) {
        // find Selected Activity Releted Packages
        let findSelectedActivityReletedPackages = this.packages.find((x) => x.id == (this.selectedPackage ?? ""));
        if (findSelectedActivityReletedPackages) {

          let packageSalesCategoryIds = findSelectedActivityReletedPackages?.salesCategories.map((category) => category);

          this.searchFacilities.forEach((asset: FacilitySummary) => {

            asset.items.forEach((item: Item) => {
              // find item salesCategories include selected activity sales category
              if (item.salesCategories?.some((category) => packageSalesCategoryIds?.includes(category.id))) {

                //get item configurations
                if ((item.itemAssets ?? []).length > 0) {
                  //get Unique Item Configurations
                  let uniqueItemConfigurations =
                    Array.from(new Map(item.itemAssets?.map((item) => [item.configuration.id, item,])).values()
                    ) ?? [];
                  if (uniqueItemConfigurations.length > 0) {
                    //loop uniqueItemConfigurations
                    uniqueItemConfigurations.forEach((itemConfiguration) => {
                      //check configuration available for releted itemConfiguration configuration id
                      let availableConfiguration = configurations.find(
                        (x) => x.id == itemConfiguration.configuration.id
                      );
                      if (availableConfiguration) {
                        // check alredy existed filteredConfigurations array
                        if (filteredConfigurations.length > 0) {
                          let findFilteredConfiguration =
                            filteredConfigurations.find(
                              (x) => x.name == availableConfiguration?.name
                            );
                          if (!findFilteredConfiguration) {
                            //check alredy not existed add configuration
                            filteredConfigurations.push(availableConfiguration);
                          }
                        } else {
                          //check alredy not existed add configuration
                          filteredConfigurations.push(availableConfiguration);
                        }
                      }
                    });
                  }
                }
              }
            });
          });
        }
      }
    }
        // IF Selected configuration available set after the filterConfigurations set
      if (this.selectedConfiguration) {
        var _cf = this.filterConfigurations.find((x) => x.id == (this.selectedConfiguration?.id ?? ''));
        if (_cf) {
          this.selectedConfiguration = this.filterConfigurations.find((x) => x.name == (_cf?.name ?? ''));
          if (this.selectedConfiguration) {
            this.onConfigurationChange(this.selectedConfiguration!);
          }
        } else {
          this.selectedConfiguration = null;
        }

      } else {
        this.selectedConfiguration = null;
      }
    */

  }

  onConfigurationChange(event: { id: string, name: string }, intialLoad: boolean = false) {
    this.selectedConfiguration = event;
    const selectedItemsForConfiguration: Item[] = [];
    //this.selectedConfigurationMatchedItems = [];
    if (!this.searchFacilities.length || !event) return;

    const configurations = this.searchFacilities
      .map(asset => asset.configurations ?? [])
      .reduce((acc, val) => acc.concat(val), []);

    if (configurations.length > 0) {
      configurations.forEach((configuration) => {
        // Check if the configuration name matches the event name
        if (configuration.name === event.name) {
          // Loop through assetViewModels
          (this.searchFacilities ?? []).forEach((asset) => {
            let facilityOpenningTime = asset.openingTime;
            let facilityClosingTime = asset.closingTime;
            // Loop through each item of the current asset
            asset.items?.map((item) => {
              // Check if the current item has associated item assets with the configuration ID
              if (
                item.itemAssets?.some(
                  (itemAsset) => itemAsset.configuration.id === configuration.id
                )
              ) {
                // Check if the item is not already in the selectedItemsRelatedConfiguration array
                if (
                  !selectedItemsForConfiguration.some(
                    (selectedItem) => selectedItem.id === item.id
                  )
                ) {

                  // Clone the itemAssets before modifying
                  let clonedItem: Item = {
                    ...item,
                    itemAssets: item.itemAssets?.map(itemAsset => ({
                      ...itemAsset,
                      facilityOpeningTime: facilityOpenningTime,
                      facilityClosingTime: facilityClosingTime
                    }))
                  };
                  selectedItemsForConfiguration.push(clonedItem);
                }
              }
            });
          });
        }
      });
    }

    /*  this.selectedConfigurationMatchedItems = selectedItemsForConfiguration;

     if (this.selectedConfigurationMatchedItems.length > 0) {
       //this.facilitySummary.selectedItem = this.selectedConfigurationMatchedItems[0];
     } */
    //this.facilitySummary.selectedItem = this.selectedConfigurationMatchedItems[0];
    // this.getTimeSlotsData(this.monthStartDate,this.monthEndDate,intialLoad, this.selectMatchingItemOnConfigurationChange.bind(this));
  }

  /*setSelectedItem(item: Item, configs: Configuration[]) {
    this.facilitySummary.selectedItem = { ...item };
    //allocate to all have all item assets
    if (!item.allocateToAllAssets) {
      this.facilitySummary.selectedItem.itemAssets = this.facilitySummary.selectedItem.itemAssets?.filter(t => (t.available ?? false) &&
        configs.findIndex(c => (c.id == t.configuration.id || (t.configuration.id ?? '') == '')) >= 0)?.slice(0, 1);
      //reset
      if ((this.facilitySummary.selectedItem.itemAssets ?? []).length == 0) {
        this.facilitySummary.selectedItem = new Item()
      }
    }
  }*/

  /*getSelectedFacilityIDsbySelectedItem(Item): string {
    let selectedFacilites: "";
    return selectedFacilites
  }*/

  populateCartData() {
    if (this.selectedPackage != "0") {
      this.selectedConfiguration =
      {
        id: this.facilitySummary.configuration.name,
        name: this.facilitySummary.configuration.name
      };
      this.facilitySummary.selectedItem = this.facilitySummary.selectedItem;
      this.selectedItemId = this.facilitySummary.selectedItem.id
      let _configs = this.allConfigurations.filter(c => c.name == this.selectedConfiguration.name);
      this.matchingItems = this.activityMatchingItems.filter(i => i.itemAssets.findIndex((s: ItemAssets) => {
        return _configs.findIndex((h: Configuration) => {
          return h.id == s.configuration?.id
        }) >= 0
      }) >= 0);

      this.facilitySummary.selectedItem = this.facilitySummary.selectedItem;
      this.selectedItemId = this.facilitySummary.selectedItem.id
    }
  }

  setLeadDaysIntoCalander(leadDays: number, freshLoad: boolean = false) {
    if (environment.DisableDatePickerForLeadDays) {
      var currentDate = new Date();
      if (leadDays < 1) {
        const minutes = leadDays * (60 * 24);
        currentDate = new Date(currentDate.getTime() + minutes * 60 * 1000);
        currentDate = moment(currentDate)
          .add(environment.MinimumBookingDuration, 'm')
          .toDate();
      } else {
        currentDate.setDate(currentDate.getDate() + leadDays);
      }
      this.minDate = currentDate;

      const minDateMoment = moment(this.minDate);

      if (this.date.isBefore(minDateMoment) && freshLoad && this.isAddFacility) {
        const combinedDateTime = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          currentDate.getDate(),
          currentDate?.getHours() || 0,
          currentDate?.getMinutes() || 0,
          currentDate?.getSeconds() || 0,
          currentDate?.getMilliseconds() || 0
        );
        this.date = moment(combinedDateTime);
        this.startTime = combinedDateTime;
        this.initializeTime();
      }
    }
  }

  setItemRemainingLeadDaysList(selectedDate: Date, items: Item[] = []) {
    this.remainingLeadDaysList = [];
    let currentTimewithMilliseconds = moment();
    let current = moment().startOf('day');
    let daysCount = moment(selectedDate).diff(current, 'days');
    if (daysCount == 0) {
      daysCount = moment(selectedDate).diff(currentTimewithMilliseconds, 'milliseconds') / (24 * 60 * 60 * 1000);
    }
    items.forEach(item => {
      let remainingLeadDays = 0;
      if (daysCount <= item.leadDays) {
        remainingLeadDays = item.leadDays - daysCount;
      }
      this.remainingLeadDaysList.push({ id: item.id, remainingLeadDays });
    });
  }

  setPackageRemainingLeadDaysList(selectedDate: Date, packages: BespokePackage[]) {
    this.remainingPackageLeadDaysList = [];
    let currentTimewithMilliseconds = moment();
    let current = moment().startOf('day');
    let daysCount = moment(selectedDate).diff(current, 'days');
    if (daysCount == 0) {
      daysCount = moment(selectedDate).diff(currentTimewithMilliseconds, 'milliseconds') / (24 * 60 * 60 * 1000);
    }
    packages.forEach(pkg => {
      let remainingLeadDays = 0;
      if (daysCount <= pkg.leadDays) {
        remainingLeadDays = pkg.leadDays - daysCount;
      }
      this.remainingPackageLeadDaysList.push({ id: pkg.id, remainingLeadDays });
    });
  }

  checkRemainingLeadDaysCount(itemId: string = null, packageId: string = null): boolean {
    if (itemId != null && packageId != null) {
      const itemMatchingEntry = this.remainingLeadDaysList.find(entry => entry.id === itemId);
      const packageMatchingEntry = this.remainingPackageLeadDaysList.find(entry => entry.id === packageId);
      return (
        (itemMatchingEntry ? itemMatchingEntry.remainingLeadDays === 0 : false) &&
        (packageMatchingEntry ? packageMatchingEntry.remainingLeadDays === 0 : false)
      );
    }
    if (itemId != null) {
      const matchingEntry = this.remainingLeadDaysList.find(entry => entry.id === itemId);
      return matchingEntry ? matchingEntry.remainingLeadDays === 0 : false;
    }
    if (packageId != null) {
      const matchingEntry = this.remainingPackageLeadDaysList.find(entry => entry.id === packageId);
      return matchingEntry ? matchingEntry.remainingLeadDays == 0 : false;
    }
    return false;
  }

  getLeadDays(selectedPackageID: string = ""): number {
    var leadDays = 0;
    var itemSetupLeadDays = 0;
    var packageSetupLeadDays = 0;
    var xmlSetupleadDays = (environment.LeadDaysForBooking == null) ? 0 : environment.LeadDaysForBooking;
    itemSetupLeadDays = this.facilitySummary?.selectedItem ? this.facilitySummary?.selectedItem.leadDays : this.facilitySummary.item.leadDays;
    if (selectedPackageID != "") {
      let selectedPackage = this.packages.find(p => p.id == selectedPackageID);
      if (selectedPackage != null) {
        packageSetupLeadDays = selectedPackage?.leadDays ?? 0;
      }
    }

    if (itemSetupLeadDays !== 0 && packageSetupLeadDays !== 0) {
      leadDays = Math.max(itemSetupLeadDays, packageSetupLeadDays);
    } else if (itemSetupLeadDays !== 0 || packageSetupLeadDays !== 0) {
      leadDays = itemSetupLeadDays || packageSetupLeadDays;
    } else {
      leadDays = xmlSetupleadDays;
    }
    return leadDays;
  }

  showPackageLevelLeadDaywarnigMessage(selectedPackageID: string = "") {
    var leadDays = this.getLeadDays(selectedPackageID);
    var isSetupPackageLevelLeadDays = false;
    this.showBookingPackageLevelLeadDayValidationMessage = false;
    let selectedPackage;
    if (selectedPackageID != "") {
      selectedPackage = this.packages.find(p => p.id == selectedPackageID);
      if (selectedPackage != null) {
        if (selectedPackage?.leadDays != undefined) {
          isSetupPackageLevelLeadDays = true;
        }
      }
    }
    this.setLeadDaysIntoCalander(leadDays);

    if (!this.checkRemainingLeadDaysCount(null, this.selectedPackage ?? null) && isSetupPackageLevelLeadDays) {
      this.bookingPackageLevelLeadDayValidationMessage =
        (environment?.BookingPackageLevelLeadDayValidationMessage ?? "")
          .replace("#LeadDays#", (Utility.getLeadTimeAsSetup(leadDays)).toString())
      this.showBookingPackageLevelLeadDayValidationMessage = true;
      this.isAvailable = false;
      this.isBookingLeadDaysError = true;
      this.showBookingLeadDayValidationMessage = false;
      return;
    }
  }


  getSetupLeadTime(leadTime) {
    return Utility.getLeadTimeAsSetup(leadTime);
  }

  async CallCustomFunctionForChangePackageOnCart(facilitySummary, action, packageDetails) {
    let _validationOutPut;

    let _options = {
      facilitySummarries: this.cartData.addedFacilites
    };

    let _formData = {};

    if (this.cartData.userDefinedFunctions && this.cartData.userDefinedFunctions.length > 0) {
      let _validateFunction = this.cartData.userDefinedFunctions.find(
        x => x.customFunctionAction.action == action
      );

      if (_validateFunction && _validateFunction.functionName && window[_validateFunction.functionName]) {
        this.cartPackageCustomFunctionActiveRequests++;
        this.loading = true;

        try {
          _validationOutPut = await window[_validateFunction.functionName](
            facilitySummary,
            _formData,
            _options,
            packageDetails
          );

          if (_validationOutPut) {
            this.checkAvailability();
          }
        } catch (err) {
          console.error("Error in CallCustomFunctionForChangePackageOnCart:", err);
        } finally {
          this.cartPackageCustomFunctionActiveRequests--;
          if (this.cartPackageCustomFunctionActiveRequests <= 0) {
            this.loading = false;
          }
        }
      }
    }

    return _validationOutPut;
  }
  isSestemLoading(): boolean {
    return this.loading || this.availableSlotsLoading || !this.isItemPricesLoaded || this.changeTimeLineLoading;
  }
}
